import { variables } from '../../../components/variables';
import React from 'react';
import { ArrowBottom } from '../../../components/Svg';
import styled from 'styled-components';

type HeaderProps = {
    title: string;
    isOpened?: boolean;
};

const Styles = styled.div<{ $isOpened?: boolean }>`
    &&& {
        display: flex;
        width: 52px;
        position: relative;
        align-items: center;
        justify-content: center;
        background: ${variables.colors['snow-white-70%']};
        border-radius: 2px;
        padding: 8px;

        h4 {
            margin: 0;
            padding: 0;
            font-size: 12px;
            font-weight: 500;
            color: ${variables.colors['road-grey-90%']};
        }

        .arrow {
            position: absolute;
            right: -18px;
            top: 3px;

            svg {
                margin-left: 6px;
                margin-right: 3px;
                transform: ${(props) => (props.$isOpened ? 'rotate(0.5turn)' : 0)};
            }
        }
    }
`;

export function Header({ title, isOpened = false }: HeaderProps) {
    return (
        <Styles $isOpened={isOpened}>
            <h4>{title}</h4>
            <div className="arrow">
                <ArrowBottom />
            </div>
        </Styles>
    );
}
